import React, { FC } from 'react';
import ArticlesOverview from '../../../components/articles/articlesOverview';
import { Container } from '../../../components/base/grid';
import Breadcrumbs from '../../../components/breadcrumbs';
import pageWrapper from '../../../hoc/pageWrapper';
import IPageViewModel from '../../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
	componentId: number;
}

const Articles: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<ArticlesOverview />
		</Container>
	);
};

export default pageWrapper(Articles);
